
const heading = document.querySelectorAll('h2.media-h2');
if (heading.length > 0) {
  const createTocArea = document.createElement('ol');
  createTocArea.className = 'toc_area';
  const tocHeader = document.createElement('p');
  tocHeader.className = 'toc_header';
  tocHeader.innerText = '目次';

  // 目次を囲むdivを作成
  const tocWrapper = document.createElement('div');
  tocWrapper.className = 'index-wrap';

  let i = 0;
  while (i < heading.length) {
    let indexNumber = i + 1;  // 連番用の変数を作成
    if (heading[i].tagName === 'H2') {
      const tocTitleH2 = document.createElement('li');
      tocTitleH2.className = 'toc_title_h2';
      tocTitleH2.innerHTML = `<a class="toc_link jsScroll" href="#${i}"><span>${indexNumber}</span> <span>${heading[i].innerText}</span></a>`;
      createTocArea.appendChild(tocTitleH2);
    }
    const tocLinks = document.createElement('div');
    tocLinks.setAttribute('id', `${i}`);
    tocLinks.setAttribute('class', 'anchor');

    // 該当要素の上部に挿入
    heading[i].parentNode.insertBefore(tocLinks, heading[i]);

    i++;
  }

  // 目次をtocWrapperに追加
  tocWrapper.appendChild(tocHeader);
  tocWrapper.appendChild(createTocArea);

  // 任意の場所に目次を挿入する
  document.querySelector('.toc').prepend(tocWrapper);
}




